import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { IFilterParams, IOrdersListItem, ISelectList } from '../../interfaces';

export function useBillingOrdersTable(): IOrdersListItem[] {
    return useContext(MobXProviderContext).RootStore.billingSystemStore.ordersList;
}

export function useBillingOrdersFilterParams(): IFilterParams {
    return useContext(MobXProviderContext).RootStore.billingSystemStore.filterParams;
}

export function useBillingCompaniesSelect(companyId?: string): ISelectList {
    const select = useContext(MobXProviderContext).RootStore.billingSystemStore.select as ISelectList;

    if (companyId) {
        return select.filter((value) => +value.id !== +companyId);
    }

    return select;
}
